import React from 'react'
import styled from '@emotion/styled'
import {Flex} from '@vio/atlas/helpers/Flex'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {cssTheme} from '@vio/atlas/themes'

const HotelCardOutline = styled.div`
  border: 1px solid ${cssTheme.colors.border.neutral.c100};
  border-radius: ${cssTheme.layout.radius.lg};
  margin-top: ${cssTheme.layout.spacing.s500};
`

const HotelTopSection = styled.div`
  padding: ${cssTheme.layout.spacing.s500};
`

const HotelDetailsSection = styled.div`
  display: flex;
  flex-direction: row;

  & > div:first-of-type {
    margin-right: ${cssTheme.layout.spacing.s400};
  }
`

const ImageSkeleton = styled.div`
  border-radius: ${cssTheme.layout.radius.lg};
  overflow: hidden;
`

const FreezeExpireAndPrice = styled.div`
  display: flex;
  flex-direction: row;
  border-top: 1px solid ${cssTheme.colors.border.neutral.c100};

  & > div {
    flex: 1;
    padding: ${cssTheme.layout.spacing.s500};
    &:last-of-type {
      border-left: 1px solid ${cssTheme.colors.border.neutral.c100};
      direction: rtl;
    }
  }
`

const PayNowSection = styled.div`
  padding: ${cssTheme.layout.spacing.s500};
  border-top: 1px solid ${cssTheme.colors.border.neutral.c100};

  & > div {
    display: flex;
    justify-content: space-between;
  }
`

const ButtonWrapper = styled.div`
  border-radius: ${cssTheme.layout.radius.sm};
  overflow: hidden;
  margin-top: ${cssTheme.layout.spacing.s500};
`

export const HotelCardSkeleton = () => (
  <HotelCardOutline>
    <HotelTopSection>
      <HotelDetailsSection>
        <ImageSkeleton>
          <SkeletonLoader width={70} height={70} />
        </ImageSkeleton>
        <div>
          <SkeletonLoader width={68} height={12} />
          <SkeletonLoader width={178} height={24} marginTop={4} />
          <SkeletonLoader width={68} height={20} marginTop={4} />
        </div>
      </HotelDetailsSection>
      <SkeletonLoader
        width={188}
        height={24}
        marginTop={24}
        marginBottom={14}
      />
    </HotelTopSection>
    <FreezeExpireAndPrice>
      <div>
        <SkeletonLoader width={92} height={22} />
        <SkeletonLoader width={48} height={24} />
      </div>
      <div>
        <SkeletonLoader width={132} height={22} />
        <SkeletonLoader width={48} height={24} />
      </div>
    </FreezeExpireAndPrice>
    <PayNowSection>
      <div>
        <SkeletonLoader width={92} height={24} />
        <SkeletonLoader width={48} height={24} />
      </div>
      <SkeletonLoader width={188} height={22} />
    </PayNowSection>
  </HotelCardOutline>
)

export const DealFreezeCTASkelton = () => (
  <ButtonWrapper>
    <Flex.Column alignItems="center" justifyContent="center" gap="s400">
      <SkeletonLoader width={280} height={22} />
      <SkeletonLoader width={358} height={48} />
    </Flex.Column>
  </ButtonWrapper>
)
